__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "nota";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.11.1", () => (Promise.all([__webpack_require__.e(300), __webpack_require__.e(760), __webpack_require__.e(527), __webpack_require__.e(518)]).then(() => (() => (__webpack_require__(17518))))));
			register("@emotion/styled", "11.11.0", () => (Promise.all([__webpack_require__.e(527), __webpack_require__.e(458), __webpack_require__.e(479)]).then(() => (() => (__webpack_require__(71479))))));
			register("@mui/icons-material", "5.14.11", () => (Promise.all([__webpack_require__.e(561), __webpack_require__.e(610), __webpack_require__.e(527), __webpack_require__.e(458), __webpack_require__.e(757)]).then(() => (() => (__webpack_require__(50610))))));
			register("@mui/material", "5.14.11", () => (Promise.all([__webpack_require__.e(300), __webpack_require__.e(561), __webpack_require__.e(288), __webpack_require__.e(520), __webpack_require__.e(527), __webpack_require__.e(458), __webpack_require__.e(929), __webpack_require__.e(757)]).then(() => (() => (__webpack_require__(3520))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(527)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-router-dom", "6.30.6", () => (Promise.all([__webpack_require__.e(767), __webpack_require__.e(976), __webpack_require__.e(527), __webpack_require__.e(929)]).then(() => (() => (__webpack_require__(84976))))));
			register("react", "18.2.0", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(96540))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};